<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" :icon_only="true" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="certificate.title"
                  v-model="certificate.title"
                  :label="$t('certificates.name')"
                  :readonly="true"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="certificate.issued_date"
                  v-model="computedIssuedDate"
                  :label="$t('certificates.issued_date')"
                  append-icon="event"
                  :readonly="true"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="certificate.issued_by"
                  v-model="certificate.issued_by"
                  :label="$t('certificates.issued_by')"
                  :readonly="true"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="certificate.company"
                  v-model="certificate.company_name"
                  :label="$t('certificates.company')"
                  :readonly="true"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4" v-if="certificate.id">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("certificates.documents") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="dc_headers"
                  :items="documents"
                  :items-per-page="documents.length"
                  :options.sync="dc_pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="dc_total"
                  :loading="dc_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.size="{ item }">
                    {{ $formatBytes(item.size) }}
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <action-button type="download" @click="downloadFile(item)" :icon_only="true" />
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "CertificateForm",

  props: ["id", "hash"],

  data() {
    return {
      page_title: "",
      predata: {},
      certificate: {},
      user_id: null,

      documents: [],
      dc_total: 0,
      dc_show_loading: false,
      dc_refresh: false,
      dc_pagination: {
        page: this.$getLocalStorage("__page_User_QrExpertise_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      dictionary: {
        attributes: {
          "certificate.title": this.$t("certificates.name"),
          "certificate.issued_date": this.$t("certificates.issued_date"),
          "certificate.issued_by": this.$t("certificates.issued_by"),
          "certificate.company": this.$t("certificates.company")
        }
      }
    }
  },

  watch: {
    dc_refresh: {
      handler() {
        if (this.dc_refresh && this.certificate.id) {
          this.dc_list()
        }
      }
    },
    dc_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_User_QrExpertise_List", newVal.page)
          }

          this.dc_refresh = true
        }
      }
    }
  },

  computed: {
    dc_headers: {
      get() {
        return [
          { text: this.$t("certificates.filename"), value: "original_filename" },
          { text: this.$t("certificates.size"), value: "size" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end" }
        ]
      }
    },
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedIssuedDate: {
      get() {
        return this.$dateFormatGetter(this.certificate.issued_date)
      },
      set(val) {
        this.$set(this.certificate, "issued_date", this.$dateFormatSetter(val))
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.title = this.$t("certificates.update_title")

    let decoded = this.$decryptString(this.id)
    decoded = decoded.split("^|^")

    if (decoded.length == 2) {
      this.user_id = decoded[0]

      // Add session checker
      this.$cookieChecker(`${this.COOKIE_PREFIX}qr_token_` + this.userid, () => {
        this.$awn.alert(this.$t("users.qr_use_access_expired"))
        this.$router.push(this.BACKEND_URL + "/my")
      })
    }

    axios
      .get(this.API_URL + "certificate/" + this.id)
      .then((res) => {
        this.certificate = res.data.data

        // JSON stringify and parse to remove variable reactiveness
        this.predata = JSON.parse(JSON.stringify(this.certificate))
        this.fieldDisabled = this.certificate.tenant_certificate_id ? true : false
        this.dc_list()

        this.page_title = this.certificate.title
      })
      .catch((err) => console.log(err))
  },

  methods: {
    dc_list() {
      this.dc_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.dc_pagination
      let query = this.$queryString(this.dc_pagination, { certificate_id: this.certificate.id })

      axios
        .get(this.API_URL + "certificate/documents" + "?" + query)
        .then((res) => {
          this.documents = res.data.data
          this.dc_total = res.data.meta.total
          this.dc_refresh = false
          this.dc_show_loading = false

          this.dc_pagination.page = res.data.meta.current_page
          this.dc_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },
    downloadFile(item) {
      axios({
        url: this.API_URL + "certificate/download",
        method: "POST",
        responseType: "arraybuffer",
        data: {
          id: item.id
        }
      })
        .then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", item.original_filename)
            link.click()
          }
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    }
  }
}
</script>

<style scoped></style>
